/**
 *  @deprecated reference RTK-generated tags instead
 */
export const TAG_TYPES = {
  BLOCK_TYPE_OPTIONS: 'BlockTypeOptions',
  BLOCK: 'Blocks',
  EXTERNAL_SURVEYS: 'ExternalSurveys',
  HIGHLIGHTER_PROFILE_SURVEYS: 'HighlighterProfileSurveys',
  LINE_ITEM: 'LineItems',
  QUESTION_DESIGNS: 'QuestionDesigns',
  QUESTION_DESIGN_CHOICES: 'QuestionDesignChoices',
  SLOT: 'Slots',
  SURVEY_CONFIG: 'SurveyConfigs',
  SURVEY_QUESTIONS: 'Questions',
  SURVEY_RESULTS: 'SurveyResults',
} as const;
